module.exports = __webpack_public_path__ + "static/img/illu-uber-01.771500b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/illu-uber-01.svg
// module id = tQVL
// module chunks = 0